import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import { FaqService } from '../../../api/faq/faq.service';
import { FaqModel } from '../../../api/faq/FaqModel';
import { ApplicationService } from '../../../api/application/application.service';
import { ComboApplication } from '../../../api/application/comboapplication';
import { ReplaceDataService } from 'api/replacedata/replacedata.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'faq-page',
    templateUrl: './faq.html'
})
export class FaqComponent implements OnInit {
    applicationList: ComboApplication[];
    selectApplication: string;
    selectDeviceType : string = "iOS";
    selectVersion : string = "2";
    faqList: FaqModel[];
    iFaq: FaqModel;
    message: string;
    id: string;
    faqno: string;
    sequenceno: number;
    question: string;
    answer: string;
    iIndex: number
    constructor(private faqservice: FaqService, private applicationService: ApplicationService,
        private router: Router, private ReplaceDataService: ReplaceDataService) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'DEVELOPER' || localStorage.getItem('type') == 'ADMIN')) {
            $(function () {
            })
            // this.selectVersion = "2";
            this.initData();
        } else {
            this.router.navigate(['/']);
        }
    }
    onApplicationChange(countryGroupValue) {
        this.selectApplication = countryGroupValue;
        this.getFAQ();
    }
    onDeviceTypeChange(dev) {
        this.selectDeviceType = dev;
        this.getFAQ();
    }
    onVersionChange(ver) {
        this.selectVersion = ver;
        this.getFAQ();
    }
    onlyNumberKey(event) {
        return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    getFAQ() {
        this.faqservice
            .allFaq(this.selectApplication,this.selectDeviceType,this.selectVersion)
            .then(
                data => {
                    this.faqList = data
                }
            );
    }
    initData() {
        this.applicationService
            .ComboApplication()
            .then(data => {
                this.applicationList = data;
                this.selectApplication = this.applicationList[0].id;
            }).then(dttt => {
                this.getFAQ();
            })
    }
    cancelAction() {
        this.sequenceno = null;
        this.question = null;
        this.answer = null;
    }
    submitFaq() {
        this.sequenceno = (this.sequenceno == null) ? 0 : this.sequenceno;
        this.question = (this.question == 'undefined' || this.question == null) ? "" : this.question;
        this.answer = (this.answer == 'undefined' || this.answer == null) ? "" : this.answer;
        if (this.sequenceno == 0) {
            $.notify({
                message: "Please Enter Faq Number."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        }
        else if (this.question == "") {
            $.notify({
                message: "Please Enter Faq Question."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        }
        else if (this.answer == "") {
            $.notify({
                message: "Please Enter Faq Answer."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        }
        else {
            if (this.answer.trim() == "" || this.question.trim() == "") {
                $.notify({
                    message: "Please Enter All Field."
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                var iFaq = {
                    applicationId: this.selectApplication,
                    sequenceno: this.sequenceno,
                    question: this.question,
                    answer: this.answer,
                    devicetype : this.selectDeviceType,
                    version : this.selectVersion
                }
                this.faqservice.inFaq(iFaq)
                    .then(data => {
                        if(data.status)
                        {
                            this.faqList.push(data.data);
                            $(function () {
                                $('#example3').modal('toggle');
                            });
                            this.cancelAction();
                        }
                        else
                        {
                            $.notify({
                                message: data.message
                            }, {
                                type: 'danger',
                                placement: {
                                    from: 'bottom',
                                    align: 'left'
                                },
                                delay: 100,
                                timer: 100
                            });
                        }
                    })
            }
        }
    }
    showFaq(index, faq) {
        this.iIndex = index;
        this.id = faq.id;
        this.sequenceno = faq.sequenceno;
        this.question = faq.question;
        this.answer = faq.answer;
    }
    updateFaq() {
        var selectApplication = $("#SELECTAPPLICATION").val();
        var uFaq = {
            applicationId: this.selectApplication,
            appid: selectApplication,
            sequenceno: this.sequenceno,
            question: this.question,
            answer: this.answer
        }
        if (this.id == 'undefined') {
            $.notify({
                message: 'Refresh Data'
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            this.cancelAction();
        } else if (this.sequenceno == 0) {
            $.notify({
                message: "Please Enter Faq Number."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        } else if (this.question == "") {
            $.notify({
                message: "Please Enter Faq Question."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        } else if (this.answer == "") {
            $.notify({
                message: "Please Enter Faq Answer."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        } else {
            this.faqservice.uFaq(this.id, uFaq)
                .then(data => {
                    if (data.status == true) {
                        this.faqList[this.iIndex] = data.data;
                                $.notify({
                                    message: data.message
                                }, {
                                    type: 'success',
                                    placement: {
                                        from: 'bottom',
                                        align: 'left'
                                    },
                                    delay: 100,
                                    timer: 100
                                });
                                this.cancelAction();
                                $(function () {
                                    $('#exampleModal').modal('toggle');
                                });
                    } else {
                        $.notify({
                            message: data.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                        this.cancelAction();
                    }
                });
        }
    }
    deleteFaq() {
        this.faqservice
            .dFaq(this.id)
            .then(data => {
                if (data.status) {
                    this.faqList.splice(this.iIndex, 1)
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    $(function () {
                        $('#deleteModal').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/faq/faq.page.ts